import { useState } from "react";
import { ErrorContent } from "../shared/error-content";
import { LoadingContent } from "../shared/loading-content";
import { DialogTitle } from "../shared/modal";
import { useEditColorCollectionsStore } from "../../../js/stores/edit-color-collections-store";
import { useAddToColorCollectionModalStore } from "../../../js/stores/add-to-color-collection-modal-store";
import {
  useGetCollectionForm,
  useEditColorCollection,
} from "../../../js/api/edit-collections/get-collection-form";
import { EditColorCollectionForm } from "./edit-color-collection-form";

export function EditColorCollectionContent({ closeClickHandler }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const collectionId = useEditColorCollectionsStore(
    (state) => state.collectionId
  );
  const isAddToCollection = useEditColorCollectionsStore(
    (state) => state.isAddToCollection
  );
  const addToCollectionUrl = useEditColorCollectionsStore(
    (state) => state.addToCollectionUrl
  );
  const openAddToColorCollectionModal = useAddToColorCollectionModalStore(
    (state) => state.openModal
  );
  const { data, isLoading, isError } = useGetCollectionForm({
    collectionId,
    isAddToCollection,
  });
  const [serverErrors, setServerErrors] = useState({});
  const editColorCollectionMutation = useEditColorCollection();
  const submitFormHandler = (body) => {
    if (data?.mainAction?.linkUrl && body) {
      setIsSubmitting(true);
      setServerErrors({});
      editColorCollectionMutation.mutate({
        url: data?.mainAction?.linkUrl,
        body,
        successHandler: (responseData) => {
          setIsSubmitting(false);
          if (!responseData?.isSuccess) {
            setServerErrors(responseData?.errors || {});
            return;
          }
          closeClickHandler();
          if (collectionId && window?.location?.reload) {
            window.location.reload();
          } else if (addToCollectionUrl) {
            openAddToColorCollectionModal(addToCollectionUrl);
          } else if (responseData?.redirectUrl && window?.location?.href) {
            window.location.href = responseData?.redirectUrl;
          }
        },
        errorHandler: (errorData) => {
          setIsSubmitting(false);
          if (errorData?.response?.data?.errors) {
            setServerErrors({ ...errorData?.response?.data?.errors });
          }
        },
      });
    }
  };

  if (isLoading || isSubmitting) {
    return <LoadingContent />;
  }

  if (isError) {
    return <ErrorContent />;
  }

  return (
    <div className="edit-color-collection-wrapper">
      <div className="edit-color-collection-content">
        <DialogTitle className="edit-color-collection-title">
          {data?.modalLabel}
        </DialogTitle>
        {data?.fields?.length > 0 && (
          <EditColorCollectionForm
            submitHandler={submitFormHandler}
            data={data}
            serverErrors={serverErrors}
            setServerErrors={setServerErrors}
            closeClickHandler={closeClickHandler}
          />
        )}
      </div>
    </div>
  );
}
